<script>
    let { onclick } = $props()
</script>

<button {onclick} class="btn-create"> + Create </button>
